import { render, staticRenderFns } from "./TimeUpdate.vue?vue&type=template&id=72c0f64f&scoped=true&"
import script from "./TimeUpdate.vue?vue&type=script&lang=js&"
export * from "./TimeUpdate.vue?vue&type=script&lang=js&"
import style0 from "./TimeUpdate.vue?vue&type=style&index=0&id=72c0f64f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72c0f64f",
  null
  
)

export default component.exports